import { IAppTheme, IUser } from '@msx/platform-services';
import { InjectedIntlProps } from 'react-intl';
export const HEADER_HEIGHT = 48;


export interface OwnProps extends InjectedIntlProps {
  showFabricComponent: boolean;
  onFabricVisibilityChanged: (isVisible: boolean) => void;
  dispatchUpdateLocaleAction: any;
  locales: any;
  isAppReady: boolean;
  isUserLoggedIn: boolean;
  theme: IAppTheme;
  appName: string;
  user: IUser;
  pageList?:any
  appNameTooltip: string;
}

export type TemplateDetails = {
  templateType:string,
  version:string
}

export enum UNIVERSAL_TEMPLATETYPE {
  EXEMPT = 'UniversalExemptTemplate',
  NONEXEMPT = 'UniversalNonExemptTemplate'
}

export type HeaderProps = OwnProps;